import {
  XsrfTokenStorageName,
  XsrfTokenRequestValue
} from "../constants/Constants";

const XsrfToken = {
  xsrfToken: undefined,

  storeToken: function(token) {
    if (window.localStorage) {
      window.localStorage.setItem(XsrfTokenStorageName, token);
    } else {
      XsrfToken.xsrfToken = token;
    }
  },

  retrieveToken: function() {
    var token;
    if (window.localStorage) {
      token = window.localStorage.getItem(XsrfTokenStorageName);
    } else {
      token = XsrfToken.xsrfToken;
    }
    if (!token) {
      token = XsrfTokenRequestValue;
    }
    return token;
  }
};

export default XsrfToken;
